// Utility functions for formatting data

export const formatCurrency = (value, fractionDigits = 0) => {
    if (typeof value !== 'number') return '₹0';
    return `₹${value.toLocaleString('en-IN', { maximumFractionDigits: fractionDigits })}`;
};

export const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
    });
};

export const formatPercentage = (value, fractionDigits = 1) => {
    if (typeof value !== 'number') return '0%';
    return `${value.toFixed(fractionDigits)}%`;
};

export const abbreviateNumber = (value) => {
    if (value >= 10000000) { // 1 crore
        return `₹${(value / 10000000).toFixed(1)}Cr`;
    } else if (value >= 100000) { // 1 lakh
        return `₹${(value / 100000).toFixed(1)}L`;
    } else if (value >= 1000) { // 1 thousand
        return `₹${(value / 1000).toFixed(1)}K`;
    }
    return formatCurrency(value);
};
